import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6d4ec4cab59d01b1129b7b0bff03a679b from "./generated-6711e3e4-6f37-4097-882b-f6f942fd885f.json";

import aa32e9035b9dd77ec1640c2b32481e949b from "./generated-9e7f728e-871a-42d0-9c85-8c9af6124ed3.json";

import a5bb5b395f6b0507941530d3c36b78ea6b from "./generated-b5fcf672-1dc2-4fdb-a100-3e76434fe645.json";

import a0e5e88e997b1c05ec8d19a7ec587d5dab from "./generated-5842a479-9c35-4886-97b9-63416971f447.json";

import a998fe91c5e0de56b57a64459b90ba5b6b from "./generated-899e97bf-1b60-4a85-88af-a40807cc63ed.json";

import ac1ccee2e305fa0251582d8d12fb0e8ffb from "./generated-273718cc-27be-4c66-a84f-c6efc941fd42.json";

import a3d0d9ae63f6a47af4702edc62d0b2dd3b from "./generated-03531e8d-4fff-4265-90b8-91038d351cf1.json";

import a02b15fa44e32f9bddf3ad54f04b6d9c9b from "./generated-3ac6a928-f63b-4ca1-866c-0a9f609b5723.json";

import a85f584958f99337e6eff3c6b47795f3eb from "./generated-38672645-4988-4384-b12c-a1046a87b67a.json";

import a999488a48c0ca9ea8534b3204b668eedb from "./generated-79c6c5cf-4c55-452d-a7d3-c4508867c189.json";

import ad0724a1d2364b8c9e44a9843b3a4f146b from "./generated-f2810e14-515c-456e-82c9-ab99acc8e76a.json";

import afb3d4c3a8de6a0954b29b9a2026588ebb from "./generated-ebe561e9-71cb-4dd4-9659-7c73106b2faf.json";

import af8581b55ef5a45979f0b3b95801163b1b from "./generated-562f4fbd-014b-4756-ad2d-97d5beab600b.json";

import a872d035e6cd3d27e10c7756f804a12f4b from "./generated-f1e9c172-d4e4-4db3-8b0c-7c1f7f359996.json";

import aaa9c0a5bcb7ab2c2a2ae95037b162a0db from "./generated-1f53cb31-730b-425e-a0a9-5123ca1f1f09.json";

import acc58a7310041092eb165e1ac742a9776b from "./generated-fcd5d45d-01af-4d19-bfc3-66487ff48441.json";

import a517c911f17709622b916330ce640bcbdb from "./generated-1c78f747-6465-4a48-a4df-284373f0cdcf.json";

import a0d675e4794e7e7697afec71640cc364db from "./generated-91ba45f5-5758-4972-9c48-fdb8a5f5f860.json";

import ad5a21d8f8dbf3b71697d7342a11347c9b from "./generated-a012a645-86ca-49ec-9d25-f4d6ee101747.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6d4ec4cab59d01b1129b7b0bff03a679b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aa32e9035b9dd77ec1640c2b32481e949b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a5bb5b395f6b0507941530d3c36b78ea6b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a0e5e88e997b1c05ec8d19a7ec587d5dab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a998fe91c5e0de56b57a64459b90ba5b6b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ac1ccee2e305fa0251582d8d12fb0e8ffb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3d0d9ae63f6a47af4702edc62d0b2dd3b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a02b15fa44e32f9bddf3ad54f04b6d9c9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a85f584958f99337e6eff3c6b47795f3eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a999488a48c0ca9ea8534b3204b668eedb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ad0724a1d2364b8c9e44a9843b3a4f146b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(afb3d4c3a8de6a0954b29b9a2026588ebb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af8581b55ef5a45979f0b3b95801163b1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a872d035e6cd3d27e10c7756f804a12f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aaa9c0a5bcb7ab2c2a2ae95037b162a0db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(acc58a7310041092eb165e1ac742a9776b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a517c911f17709622b916330ce640bcbdb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a0d675e4794e7e7697afec71640cc364db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad5a21d8f8dbf3b71697d7342a11347c9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a517c911f17709622b916330ce640bcbdb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */